import React, { useEffect, useState } from "react";
import DefaultGrid from "../Default/DefaultGrid";
import { FrontEndRoutes } from "../../config/front-end-routes";
import { useNavigate } from "react-router-dom";
import { api } from "../../config/api";
import { BackEndRoutes } from "../../config/back-end-routes";
import ModalDelete from "../Modal/ModalDelete";
import { useFilters } from "../Filters/UseFilter";
import { toast } from "react-toastify";

interface Cliente {
  cnpj: string;
  razao: string;
  nome_fantasia: string;
  celular: string;
  telefone: string;
  status: number;
}

interface props {
  clients: any;
  reload: any;
}

const GridClients: React.FC<props> = ({ clients, reload }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [deleting, setDeleting] = useState(false);
  const [showModal, setShowModal] = useState<boolean>(false)
  const [selectedItem, setSelectedItem] = useState<Cliente | null>(null);
  const { filters, handleFilterChange } = useFilters([]);
  const [customers, setCustomers] = useState<any[]>([]);
  const [filteredCustomers, setFilteredCustomers] = useState<any[]>([]);
  const columns = [
    {
      key: "cnpj",
      label: "CNPJ",
      filterType: "text",
      render: (item: any) => (
        <span>
          {item.cpf
            ? item.cpf.replace(
              /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
              "$1.$2.$3-$4"
            )
            : item.cnpj
              ? item.cnpj.replace(
                /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
                "$1.$2.$3/$4-$5"
              )
              : "Não informado"}
        </span>
      ),
    },
    {
      key: "razao",
      label: "Razão Social",
      filterType: "text",
      class: "col-2 col-md-3 col-sm-4 hidden-xs-down",
    },
    {
      key: "nome_fantasia",
      label: "Nome Fantasia",
      filterType: "text",
    },
    {
      key: "celular",
      label: "Telefone",
      filterType: "text",
      render: (item: any) => {
        const phone = item.phone || item.celular || "";
        if (!phone) {
          return <span>Não informado</span>;
        }

        const formattedPhone = phone.replace(
          phone.length > 10
            ? /^(\d{2})(\d{1})(\d{4})(\d{4})$/
            : /^(\d{2})(\d{4})(\d{4})$/,
          phone.length > 10 ? "($1) $2 $3-$4" : "($1) $2-$3"
        );

        return <span>{formattedPhone}</span>;
      },
    },
    {
      key: "status",
      label: "Status",
      filterType: "select",

      options: [
        { value: "1", description: "Ativo" },
        { value: "0", description: "Inativo" },
      ],
      render: (item: any) => (
        <select
          className="form-select"
          value={item.status}
          disabled
          onChange={(e) => {
            const newStatus = parseInt(e.target.value, 10);
            api
              .put(
                BackEndRoutes.routes.CLIENTES.EDIT.replace(":id", item.id),
                { status: newStatus }
              )
              .then(() => {
                setCustomers((prev) =>
                  prev.map((term) =>
                    term.id === item.id
                      ? { ...term, status: newStatus }
                      : term
                  )
                );
                toast.success("Status atualizado com sucesso!");
              })
              .catch(() => {
                toast.error("Erro ao atualizar status.");
              });
          }}
        >
          <option value={1}>Ativo</option>
          <option value={0}>Inativo</option>
        </select>
      ),
    },
  ];

  const handleDelete = () => {
    setDeleting(true);

    api.delete(BackEndRoutes.routes.CLIENTES.DELETE.replace(':cnpj', selectedItem?.cnpj))
      .then(() => {
        setShowModal(false);
        setSelectedItem(null);
        reload();
      })
      .catch((error) => {
        console.error("Erro ao deletar cliente:", error);
        toast("Não foi possível deletar o cliente.");
      })
      .finally(() => {
        setDeleting(false);
      });
  };

  useEffect(() => {
  }, []);

  return (
    <div>
      <DefaultGrid
        title="Lista de Clientes"
        onAdd={() => navigate(FrontEndRoutes.CLIENTES.CREATE)}
        columns={columns}
        filters={filters}
        handleFilterChange={handleFilterChange}
        items={clients}
        itemsPerPage={10}
        loading={loading}
        onReload={reload}
        onEdit={(item: any) => {
          if (item?.cnpj) {
            navigate(FrontEndRoutes.CLIENTES.EDIT.replace(":id", item.cnpj));
          }
        }}
        onDelete={(item) => { setShowModal(true); setSelectedItem(item) }}
      />

      <ModalDelete
        show={showModal}
        title="Confirmar Delete"
        message={`Deseja confirmar a exclusão do cliente com CPF/CNPJ: ${selectedItem?.cnpj}?`}
        loading={deleting}
        onConfirm={handleDelete}
        onCancel={() => {
          setShowModal(false);
          setSelectedItem(null);
        }}
      />
    </div>
  );
};

export default GridClients;
